/* Ardor Real Estate Sign Designer: product (Yard Sign + H-Stake, Real Estate A-Frame, Real Estate Post, Real Estate
Frame), then the supplier's option groups for that product in their wording and order (sign + hardware or sign only,
size, graphic sides, rider, pennant flag, holes, grommets, material), quantity (or pack), delivery, live price, artwork on
each printed piece's template (the sign and the optional rider, front and back), 3D preview, proof approval, cart and
quote. Ardor Printing. New Oct 19, 2026 (RE-CORE). Made from a copy of the LIVE assets/ardor-stand-builder.js (unchanged,
Oct 19 2026, incl. its Oct 12 tpl upload budget; its Oct 18 LED add-on step is left out) by the patch list
realestate/core/builder.patch. Loaded by sections/ardor-realestate-builder-ws-kit.liquid.
Two pieces: the sign and, on the A-frame, post and frame, an optional rider. Face ids used everywhere (builder, layers,
3D, AI hand-off, print files, proof): 'front', 'back' (the sign), 'rider-front', 'rider-back' (the rider). S.piece = the
piece being edited, S.face = its side ('front' | 'back'); a back shows "Same as front" or its own art (S.backMode for the
sign, S.rBackMode for the rider). Every piece is drawn at true proportions from its print template
(window.ArdorRealestateSpecs, assets/ardor-realestate-specs.js): the page, the visible area, the zones the hardware covers
(frame lip, clips, rider clamp, grommets), the holes and the dashed safe line. Print files: one PDF page per printed face
at the piece's template size x 72 pt. Works with ardor-realestate-layers-kit.js (text, clipart, templates, QR),
ardor-realestate-ai.js (AI design), ardor-realestate3d.js (3D view) and ardor-realestate-pdf.js (proof and print PDFs). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- real estate signs, variants and prices ----------
  // One Shopify variant per sign size, order (sign + hardware / sign only), price-changing option (yard sign sides, rider,
  // A-frame pennant flag) and pack. The section writes every variant into the config: k = SKU
  // ("RE-<KEY>-<KIT|GO>[-1S|-2S][-R0|-R24x6|-R36x6][-FLAG]-Q<pack>", any letter case), o1 / o2 / o3 = option values, id,
  // c = price of ONE pack in cents (Q1 = one sign), a = available. The cart line quantity = packs (signs when Q1).
  // FALLBACK (window.ArdorRealestateSpecs.fallback, cents by SKU) is only used when the config has no variants, so a price
  // always shows; Add to cart then asks the customer to call. Liquid lists only the first 250 variants: the ones past 250
  // are read live (see readLate) and show their fallback price until then. Every product is sold in packs of 1 to 100
  // signs; one online order is up to MAX_SIGNS signs, more goes to a quote.
  var SPECS = window.ArdorRealestateSpecs || {};
  var KEYS = SPECS.keys || {};
  var FALLBACK = SPECS.fallback || {};
  var PACKS = SPECS.packs || {};
  var FAMS = (SPECS.fams || []).filter(function (f) { return f && f.keys && f.keys.length && f.groups; });
  var MAX_QTY = 100;      // packs (or single signs) in one order
  var MAX_SIGNS = 500;    // signs in one online order (5 packs of 100); more is a quote
  function maxQty(pack) { return Math.max(1, Math.min(MAX_QTY, Math.floor(MAX_SIGNS / (+pack || 1)))); }
  var SAFE = 0.25; // inches inside the visible area for the dashed red safe line when the template gives none
  var MAX_FILE = 25 * 1024 * 1024;
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';
  var PREFIX = { yard: 'YS', aframe: 'RA', post: 'RP', frame: 'RF' };
  var NOFAM = { id: '', name: '', sub: '', short: 'sign', keys: [], groups: [], dflt: {} };

  var KEY_UC = {}; Object.keys(KEYS).forEach(function (k) { KEY_UC[k.toUpperCase()] = k; });
  // a sign key as written in the specs (sizes have a lowercase x: RP-24x18), any letter case accepted
  function normKey(s) { s = String(s || '').trim(); return KEYS[s] ? s : (KEY_UC[s.toUpperCase()] || ''); }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function famOf(id) { for (var i = 0; i < FAMS.length; i++) if (FAMS[i].id === id) return FAMS[i]; return NOFAM; }
  function famOfKey(key) { var e = KEYS[key]; return famOf(e ? e.fam : ''); }
  function realVals(g) { return (g.values || []).filter(function (v) { return !v.hdr; }); }
  function valOf(g, v) { var o = null; realVals(g).forEach(function (x) { if (x.v === v) o = x; }); return o; }
  function sizeGroup(fam) { return fam.groups.filter(function (g) { return g.role === 'size'; })[0] || null; }
  function sizeVal(fam, key) { var g = sizeGroup(fam), o = g ? realVals(g).filter(function (x) { return x.key === key; })[0] : null; return o ? o.v : ''; }
  // the supplier's own show / hide rules ("hardware != so", "size in 24x18,24x24")
  function shows(w, sel) {
    if (!w) return true;
    var cur = sel[w.g];
    if (w.op === '!=' || w.op === '!in') return w.v.indexOf(cur) < 0;
    return w.v.indexOf(cur) >= 0;
  }
  // the rider size a rider value stands for ('*' = the sign's own rider; '' = no rider)
  function riderOf(key, r) {
    var e = KEYS[key]; if (!r || !e || !e.riders) return '';
    if (r === '*') { var ks = Object.keys(e.riders); return ks[0] || ''; }
    return e.riders[r] ? r : '';
  }
  function valShows(key, g, v, sel) { return shows(v.when, sel) && !(g.role === 'rider' && v.rider && !riderOf(key, v.rider)); }
  // the picked value of every group, made valid for this sign: a hidden group has no value, a hidden or unknown value
  // falls back to the supplier's default, then to the first value that shows (two passes: rules can look ahead)
  function resolveSel(fam, key, want) {
    var sel = { size: sizeVal(fam, key) };
    for (var pass = 0; pass < 2; pass++) {
      fam.groups.forEach(function (g) {
        if (g.role === 'size') { sel[g.id] = sizeVal(fam, key); return; }
        if (!shows(g.when, sel)) { sel[g.id] = null; return; }
        var vis = realVals(g).filter(function (v) { return valShows(key, g, v, sel); });
        var w = want && want[g.id] != null ? want[g.id] : sel[g.id];
        var pick = vis.filter(function (v) { return v.v === w; })[0];
        // the supplier swaps the rider to the one that fits a new sign width (24 x 6 <-> 36 x 6): keep "a rider" picked
        if (!pick && g.role === 'rider' && w != null) { var wv = valOf(g, w); if (wv && wv.rider) pick = vis.filter(function (v) { return !!v.rider; })[0]; }
        pick = pick || vis.filter(function (v) { return v.v === fam.dflt[g.id]; })[0] || vis[0];
        sel[g.id] = pick ? pick.v : null;
      });
    }
    return sel;
  }
  // the combo code of a selection (the SKU between the key and -Q): order, then sides (yard sign), rider, pennant flag
  function comboOf(fam, key, sel) {
    var p = { order: 'KIT', sides: '', rider: '', flag: '' }, faces = 0, rider = '', flag = false;
    fam.groups.forEach(function (g) {
      var v = sel[g.id] == null ? null : valOf(g, sel[g.id]);
      if (!v) return;
      if (g.role === 'order') p.order = v.code || 'KIT';
      else if (g.role === 'sides') { faces = v.faces || 0; if (g.sku) p.sides = v.code || ''; }
      else if (g.role === 'rider') { rider = riderOf(key, v.rider); p.rider = 'R' + (rider || '0'); }
      else if (g.role === 'flag') { flag = v.code === 'FLAG'; p.flag = v.code || ''; }
    });
    return { order: p.order, code: [p.order, p.sides, p.rider, p.flag].filter(Boolean).join('-'), faces: faces, rider: rider, flag: flag };
  }
  function skuOf(key, code, pack) { return 'RE-' + key + '-' + code + '-Q' + (pack || 1); }
  // the sign key, combo code and pack of a variant: from its SKU, else from its option values
  function parseSku(k) {
    var m = /^RE-([A-Z]{2}-\d+(?:\.\d+)?x\d+(?:\.\d+)?)-((?:KIT|GO)(?:-[A-Z0-9.]+)*?)-Q(\d+)$/i.exec(String(k || '').trim());
    if (!m) return null;
    var key = normKey(m[1]);
    return key ? { key: key, code: m[2].toUpperCase(), pack: +m[3] } : null;
  }
  // a variant without a readable SKU (should not happen): its option values must name the product, the sign size and the
  // order; rider, graphic sides, pennant flag and pack are read from the same text
  function fromOptions(v) {
    var t = [v.o1, v.o2, v.o3].map(function (x) { return String(x == null ? '' : x); }).join(' | ').toLowerCase().replace(/[“”″]/g, '"');
    var fam = /yard/.test(t) ? 'yard' : (/a-?frame/.test(t) ? 'aframe' : (/post/.test(t) ? 'post' : (/frame/.test(t) ? 'frame' : '')));
    var sz = [], re = /(\d+(?:\.\d+)?)\s*"?\s*(?:in)?\s*x\s*(\d+(?:\.\d+)?)/g, m;
    while ((m = re.exec(t))) sz.push(m[1] + 'x' + m[2]);
    if (!fam || !sz.length) return null;
    var key = normKey(PREFIX[fam] + '-' + sz[0]); if (!key) return null;
    var e = KEYS[key], order = /sign only/.test(t) ? 'GO' : 'KIT';
    var rider = sz.slice(1).filter(function (s) { return e.riders && e.riders[s]; })[0] || '';
    var parts = [order];
    if (fam === 'yard') parts.push(/single/.test(t) ? '1S' : '2S');
    if (fam !== 'yard') parts.push('R' + (rider || '0'));
    if (fam === 'aframe' && order === 'KIT' && /flag/.test(t) && !/(no (pennant )?flag|flag: ?no)/.test(t)) parts.push('FLAG');
    var pk = /(\d+)\s*(?:pack|signs)\b/.exec(t);
    var code = parts.join('-'), pack = pk ? +pk[1] : 1;
    return FALLBACK[skuOf(key, code, pack)] != null ? { key: key, code: code.toUpperCase(), pack: pack } : null;
  }
  var VAR = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var p = parseSku(v.k) || fromOptions(v);
    if (!p) return;
    var cents = Math.round(Number(v.c));
    VAR[p.key + '|' + p.code + '|' + p.pack] = { id: v.id || null, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || '') };
    LIVE = true;
  });
  // the variant Liquid selected (config "sofa": ?variant=<id>, or the first available one) is live data too, even when it
  // is past the first 250
  (function (v) {
    var p = v && v.id ? parseSku(v.k) : null; if (!p || !LIVE) return;
    var id = p.key + '|' + p.code + '|' + p.pack, cents = Math.round(Number(v.c));
    if (!VAR[id]) VAR[id] = { id: v.id, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || '') };
  })(CONF.sofa);
  var FB = {};
  Object.keys(FALLBACK).forEach(function (s) { var p = parseSku(s); if (p) FB[p.key + '|' + p.code + '|' + p.pack] = Math.round(Number(FALLBACK[s])) || 0; });
  // ---------- variants past the first 250 ----------
  // Liquid's product.variants lists the first 250 variants only. When the product has more (CONF.variantsCount), a variant
  // the specs price but the list lacks is read live: this section rendered for that variant's option values
  // (?option_values=<ids>&section_id=<id>, the same way sections/ardor-style-product.liquid does it); its config "sofa" is
  // that variant (id, SKU, live price, availability). The option values come from a listed variant of the same combo and
  // the Quantity value of the pack. Read once after load, and again before Add to cart if needed.
  var MORE = LIVE && (+CONF.variantsCount || 0) > (CONF.variants || []).length && !!CONF.sectionId;
  var LATE = {};
  function lateIds(key, code, pack) {
    var base = null;
    (CONF.variants || []).forEach(function (v) { var p = v && parseSku(v.k); if (!base && p && p.key === key && p.code === code && v.o1 != null) base = [v.o1, v.o2, v.o3]; });
    if (!base) return null;
    var opts = CONF.options || [], ids = [];
    for (var i = 0; i < opts.length; i++) {
      var vals = opts[i] || [], hit = null;
      var isQty = vals.length > 0 && vals.every(function (x) { return /^\d+\s*signs?$/i.test(String(x[1]).trim()); });
      vals.forEach(function (x) { if (!hit && (isQty ? +String(x[1]).match(/\d+/)[0] === pack : String(x[1]) === String(base[i]))) hit = x; });
      if (!hit || hit[0] == null) return null;
      ids.push(hit[0]);
    }
    return ids.length ? ids : null;
  }
  function readLate(key, code, pack) {
    code = String(code || '').toUpperCase(); pack = +pack || 1;
    var id = key + '|' + code + '|' + pack;
    if (VAR[id]) return Promise.resolve(VAR[id]);
    if (LATE[id]) return LATE[id];
    var ids = MORE ? lateIds(key, code, pack) : null;
    if (!ids || !window.fetch || !window.DOMParser) return Promise.reject(new Error('no variant'));
    var base = String(CONF.productUrl || window.location.pathname);
    var url = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'option_values=' + ids.join(',') + '&section_id=' + encodeURIComponent(CONF.sectionId);
    LATE[id] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html'), el = d.querySelector('[data-abb-config]');
      var cf = el ? JSON.parse(el.textContent) : null, v = cf && cf.sofa, p = v && parseSku(v.k);
      if (!p || p.key + '|' + p.code + '|' + p.pack !== id || !v.id) throw new Error('variant not found');
      var cents = Math.round(Number(v.c));
      VAR[id] = { id: v.id, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || ''), late: true };
      return VAR[id];
    });
    LATE[id].then(function () { if (typeof render === 'function') render(); }, function () { delete LATE[id]; });
    return LATE[id];
  }
  // the variant for a sign, combo and pack. none = the product has no such variant (not offered)
  function variantFor(key, code, pack) {
    var id = key + '|' + String(code || '').toUpperCase() + '|' + (+pack || 1);
    if (VAR[id]) return VAR[id];
    if (LIVE && MORE && FB[id]) return { id: null, cents: FB[id], available: true, pending: true, sku: skuOf(key, String(code || '').toUpperCase(), +pack || 1) };
    if (LIVE) return { id: null, cents: 0, available: false, none: true, sku: '' };
    var x = FB[id] || 0;
    return { id: null, cents: x, available: false, none: !x, sku: x ? skuOf(key, code, pack) : '' };
  }
  // the pack sizes a sign and combo can be ordered in (1 = single signs), smallest first
  function packsFor(key, code) {
    var ps = (PACKS[key] || [1]).slice();
    if (LIVE) Object.keys(VAR).forEach(function (id) { var p = id.split('|'); if (p[0] === key && ps.indexOf(+p[2]) < 0) ps.push(+p[2]); });
    ps.sort(function (a, b) { return a - b; });
    return ps.filter(function (q) { return !variantFor(key, code, q).none; });
  }
  // every selection the picker can make for a sign (each group with a choice, every value), made valid
  function allSels(fam, key) {
    var gs = fam.groups.filter(function (g) { return g.role !== 'size' && realVals(g).length > 1; }), out = [];
    (function rec(i, want) {
      if (i === gs.length) { out.push(resolveSel(fam, key, want)); return; }
      realVals(gs[i]).forEach(function (v) { var w = Object.assign({}, want); w[gs[i].id] = v.v; rec(i + 1, w); });
    })(0, {});
    return out;
  }
  var CODES = {};
  function codesFor(key) {
    if (CODES[key]) return CODES[key];
    var fam = famOfKey(key), seen = {}, out = [];
    allSels(fam, key).forEach(function (sel) { var cb = comboOf(fam, key, sel); if (!seen[cb.code]) { seen[cb.code] = 1; out.push(cb.code); } });
    return (CODES[key] = out);
  }
  function keyOffered(key) { return codesFor(key).some(function (cd) { return packsFor(key, cd).length > 0; }); }
  function keysShown(fam) { return (fam.keys || []).filter(function (k) { return KEYS[k] && keyOffered(k); }); }
  function famsShown() { return FAMS.filter(function (f) { return keysShown(f).length > 0; }); }

  // ---------- print template geometry (per piece: the sign, and the rider when there is one) ----------
  // Inches from the template page's top-left (y down): the page (what we print), the visible area (what shows when the
  // sign is up), the zones the hardware covers (frame lip, clips, rider clamp, grommets), the holes, the keep-clear zones
  // around hanging holes and the dashed safe line. A back is seen from the back, so its zones and holes are mirrored left
  // to right (all supplier hardware is symmetric today, so this changes nothing yet).
  var GEO = {};
  function R4(a) { return a && a.length === 4 && a.every(function (x) { return isFinite(+x); }) ? a.map(Number) : null; }
  function rectPts(r) { return [[r.x, r.y], [r.x + r.w, r.y], [r.x + r.w, r.y + r.h], [r.x, r.y + r.h]]; }
  function pieceSpec(key, piece, rider) { var e = KEYS[key] || {}; return piece === 'rider' ? ((rider && e.riders && e.riders[rider]) || null) : (e.sign || null); }
  function geoFor(key, piece, rider, back) {
    var id = [key, piece, rider || '', back ? 'b' : 'f'].join('|');
    if (GEO[id]) return GEO[id];
    var t = pieceSpec(key, piece, rider) || (KEYS[key] || {}).sign || { W: 24, H: 18 };
    var W = +t.W || 24, H = +t.H || 18, b = Math.max(0, +t.bleed || 0);
    var mx = function (r) { return back ? { x: W - r.x - r.w, y: r.y, w: r.w, h: r.h } : r; };
    var v = R4(t.vis) || [b, b, W - 2 * b, H - 2 * b];
    var box = function (z) { var r = R4(z && (z.r || z.rect)); return r ? mx({ x: r[0], y: r[1], w: r[2], h: r[3] }) : null; };
    var g = { W: W, H: H, bleed: b, piece: piece, rider: rider || '', placeholder: false, faces: +t.faces === 2 ? 2 : 1,
      vis: mx({ x: v[0], y: v[1], w: v[2], h: v[3] }),
      hidden: (t.hidden || []).map(function (z) { var r = box(z); return r ? Object.assign(r, { why: String(z.why || 'Hidden'), k: String(z.k || '') }) : null; }).filter(Boolean),
      keep: (t.keep || []).map(function (z) { var r = box(z); return r ? Object.assign(r, { why: 'Hole' }) : null; }).filter(Boolean),
      holes: (t.holes || []).filter(function (h) { return h && h.length >= 3; }).map(function (h) { return [back ? W - +h[0] : +h[0], +h[1], +h[2]]; }),
      holeKind: t.holeKind || 'hole', flutes: t.flutes || null, material: t.material || '',
      trim: { x: b, y: b, w: W - 2 * b, h: H - 2 * b }, grommets: [], pockets: [] };
    var sr = R4(t.safe);
    g.safeR = sr ? mx({ x: sr[0], y: sr[1], w: sr[2], h: sr[3] }) : { x: g.vis.x + SAFE, y: g.vis.y + SAFE, w: Math.max(1, g.vis.w - 2 * SAFE), h: Math.max(1, g.vis.h - 2 * SAFE) };
    g.safeIn = SAFE;
    g.cut = rectPts(g.trim); g.cutPoly = false;
    g.safe = [rectPts(g.safeR)];
    g.face = [g.vis.x, g.vis.y, g.vis.x + g.vis.w, g.vis.y + g.vis.h];
    g.bx = g.vis.x; g.by = g.vis.y; g.bw = g.vis.w; g.bh = g.vis.h;
    return (GEO[id] = g);
  }
  // face ids: 'front', 'back' (the sign), 'rider-front', 'rider-back' (the rider). A '-flat' end is accepted and ignored.
  var FACES = ['front', 'back', 'rider-front', 'rider-back'];
  function pieceOf(f) { return /^rider/.test(String(f || '')) ? 'rider' : 'sign'; }
  function isBack(f) { return /back/.test(String(f || '')); }
  function fid(piece, side) { return (piece === 'rider' ? 'rider-' : '') + (side === 'back' ? 'back' : 'front'); }
  function normFace(f) { f = String(f || '').replace(/-flat$/, ''); return FACES.indexOf(f) >= 0 ? f : 'front'; }
  // the geometry of a face of this order: its piece's template, the back mirrored on a 2-sided piece
  function faceGeo(c, face) {
    var p = pieceOf(face) === 'rider' && c.rider ? 'rider' : 'sign', pc = p === 'rider' ? c.rider : c.sign;
    return geoFor(c.key, p, p === 'rider' ? c.riderSize : '', isBack(face) && pc.sides === 2);
  }

  var S = { fam: '', key: '', sel: {}, pack: 1, qty: 1, delivery: 'ship', piece: 'sign', face: 'front', back: false, backMode: 'same', rBackMode: 'same', artVer: 0 };
  var ART = { front: null, back: null, 'rider-front': null, 'rider-back': null };
  if (MORE) setTimeout(function () {
    var n = 0;
    Object.keys(FB).forEach(function (id) { if (VAR[id] || n >= 12) return; n++; var q = id.split('|'); readLate(q[0], q[1], +q[2]).catch(function () {}); });
  }, 1200);
  var eng = null;
  (function () {
    // ?variant=<id> (Google Shopping, Shopify variant links) opens that exact variant: sign, every option and pack, quantity 1
    // (a variant past the first 250 is the config "sofa", which Liquid sets to the ?variant= one). A link to one sign
    // (?sign=<KEY>, any letter case) opens on it, and wins when it names another sign. Else the section's default sign (the
    // yard sign). ?preset= and the AI hand-off run after this, so they still win.
    var want = normKey(CONF.defaultSign), q = '', qs = null, qv = null;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { qs = null; }
    var vid = qs ? String(qs.get('variant') || '').trim() : '';
    if (qs && (qs.get('preset') || qs.get('ai'))) vid = ''; // a preset or an AI design link sets the order itself
    if (/^\d+$/.test(vid)) {
      (CONF.variants || []).concat(CONF.sofa ? [CONF.sofa] : []).forEach(function (v) { if (!qv && v && String(v.id) === vid) qv = parseSku(v.k) || fromOptions(v); });
      if (qv && keysShown(famOfKey(qv.key)).indexOf(qv.key) >= 0) want = qv.key; else qv = null;
    }
    q = qs ? normKey(qs.get('sign') || '') : '';
    if (q && keysShown(famOfKey(q)).indexOf(q) >= 0 && (!qv || q !== qv.key)) { want = q; qv = null; }
    var fams = famsShown(), f = want ? famOfKey(want) : (fams[0] || NOFAM);
    var ks = keysShown(f);
    S.key = ks.indexOf(want) >= 0 ? want : (ks[0] || '');
    S.fam = f.id;
    if (qv && S.key === qv.key) {
      var hit = allSels(f, S.key).filter(function (sel) { return comboOf(f, S.key, sel).code.toUpperCase() === String(qv.code).toUpperCase(); })[0];
      if (hit) { S.sel = hit; S.pack = qv.pack; S.qty = 1; }
    }
  })();

  // c.Wi x c.Hi = the template page of the piece being edited (c.piece), in inches; c.sign / c.rider = both pieces.
  // c.qty = packs (signs when the pack is 1). c.sel = the picked value of every supplier option group.
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var fams = famsShown(), fam = famOf(s.fam);
    if (fams.indexOf(fam) < 0) fam = (s.key && fams.indexOf(famOfKey(s.key)) >= 0) ? famOfKey(s.key) : (fams[0] || NOFAM);
    var ks = keysShown(fam), key = ks.indexOf(s.key) >= 0 ? s.key : (ks[0] || fam.keys[0] || '');
    var sel = resolveSel(fam, key, s.sel || {}), cb = comboOf(fam, key, sel);
    if (!packsFor(key, cb.code).length) { // a combo with no price: the nearest one that has one
      var alt = allSels(fam, key).filter(function (x) { return packsFor(key, comboOf(fam, key, x).code).length > 0; })[0];
      if (alt) { sel = alt; cb = comboOf(fam, key, sel); }
    }
    var packs = packsFor(key, cb.code), pack = packs.indexOf(+s.pack) >= 0 ? +s.pack : (packs[0] || 1);
    var e = KEYS[key] || { sign: { W: 24, H: 18, faces: 1 }, riders: {} };
    var rider = cb.rider && e.riders && e.riders[cb.rider] ? cb.rider : '';
    var qty = Math.max(1, Math.min(maxQty(pack), Math.round(Number(s.qty)) || 1));
    var c = { fam: fam, famId: fam.id, key: key, e: e, st: e, sel: sel, combo: cb.code, order: cb.order, flag: cb.flag, pack: pack, packs: packs,
      qty: qty, delivery: s.delivery === 'pickup' ? 'pickup' : 'ship', riderSize: rider, artVer: s.artVer, v: variantFor(key, cb.code, pack) };
    var sides = cb.faces || (+(e.sign && e.sign.faces) === 2 ? 2 : 1);
    c.sign = { piece: 'sign', sides: sides, geo: geoFor(key, 'sign', '', false) };
    c.sign.Wi = c.sign.geo.W; c.sign.Hi = c.sign.geo.H;
    c.rider = rider ? { piece: 'rider', size: rider, sides: +e.riders[rider].faces === 2 ? 2 : 1, geo: geoFor(key, 'rider', rider, false) } : null;
    if (c.rider) { c.rider.Wi = c.rider.geo.W; c.rider.Hi = c.rider.geo.H; }
    c.sides = sides; c.rsides = c.rider ? c.rider.sides : 0;
    c.piece = s.piece === 'rider' && c.rider ? 'rider' : 'sign';
    var P = c.piece === 'rider' ? c.rider : c.sign;
    c.geo = P.geo; c.Wi = P.Wi; c.Hi = P.Hi; c.pieceSides = P.sides;
    c.W = c.Wi / 12; c.H = c.Hi / 12; // feet, for shared kit code that reads them
    c.bm = { sign: s.backMode === 'different' ? 'different' : 'same', rider: s.rBackMode === 'different' ? 'different' : 'same' };
    c.backMode = c.bm[c.piece];
    return c;
  }
  // the faces that get their own print file: the sign front, its back when it has its own art, the rider front and the
  // rider's back when it has its own art
  function printedFaces(c) {
    var out = ['front'];
    if (c.sides === 2 && c.bm.sign === 'different') out.push('back');
    if (c.rider) { out.push('rider-front'); if (c.rsides === 2 && c.bm.rider === 'different') out.push('rider-back'); }
    return out;
  }
  // each = one pack (one sign when the pack is 1); charged = what goes in the cart
  function price(c) {
    var each = c.v.cents / 100;
    return { each: each, charged: each * c.qty, unit: c.pack > 1 ? each / c.pack : each, vid: c.v.id, disc: 0 };
  }
  // the lowest price a sign can be ordered for (one sign, or the smallest pack), optionally for combos passing test
  function fromKey(key, test) {
    var lo = 0;
    codesFor(key).forEach(function (cd) { if (test && !test(cd)) return; var ps = packsFor(key, cd); if (!ps.length) return; var v = variantFor(key, cd, ps[0]); if (v.cents > 0 && (!lo || v.cents < lo)) lo = v.cents; });
    return lo;
  }
  function famFrom(fam) { var lo = 0; keysShown(fam).forEach(function (k) { var x = fromKey(k); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }
  // the price of the order with one group's value changed (0 = not offered)
  function priceWith(c, g, v) {
    var want = Object.assign({}, c.sel); want[g.id] = v.v;
    var sel = resolveSel(c.fam, c.key, want); if (sel[g.id] !== v.v) return 0;
    var cb = comboOf(c.fam, c.key, sel), ps = packsFor(c.key, cb.code), q = ps.indexOf(c.pack) >= 0 ? c.pack : ps[0];
    return q ? variantFor(c.key, cb.code, q).cents : 0;
  }
  // the price of the same order on another sign size
  function priceForKey(c, key) {
    var sel = resolveSel(c.fam, key, c.sel), cb = comboOf(c.fam, key, sel), ps = packsFor(key, cb.code), q = ps.indexOf(c.pack) >= 0 ? c.pack : ps[0];
    return q ? variantFor(key, cb.code, q).cents : fromKey(key);
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function inchTxt(n) { return fmt(Math.round(n * 4) / 4); }
  function sizeName(key) { return (KEYS[key] && KEYS[key].size) || key; }
  function pieceSize(g) { return inchTxt(g.W) + ' x ' + inchTxt(g.H) + ' in'; }
  function visTxt(g) { return inchTxt(g.vis.w) + ' x ' + inchTxt(g.vis.h) + ' in'; }
  function tplTxt(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; }
  // the supplier wording of the value picked in a group with this role ('' = none)
  function selLabel(c, role) { var out = ''; c.fam.groups.forEach(function (g) { if (g.role === role && c.sel[g.id] != null) { var v = valOf(g, c.sel[g.id]); if (v) out = v.label; } }); return out; }
  function productLabel(c) { return c.fam.name || 'Real estate sign'; }
  function standLabel(c) { return productLabel(c); }
  function sizeLabel(c) { return sizeName(c.key) + ' sign (width x height)'; }
  function pieceSizeLabel(c, p) { return p === 'rider' && c.rider ? pieceSize(c.rider.geo) + ' rider (width x height)' : sizeLabel(c); }
  function sidesLabel(c) { return c.sides === 2 ? 'Double sided (front and back)' : 'Single sided'; }
  function orderLabel(c) { return selLabel(c, 'order') || (c.order === 'GO' ? 'Sign Only' : 'Sign + hardware'); }
  function riderLabel(c) { return c.rider ? pieceSize(c.rider.geo) + ' rider, ' + (c.rsides === 2 ? 'double sided' : 'single sided') : 'No rider'; }
  function hwLabel(c) {
    if (c.order === 'GO') return 'None (sign only)';
    var hw = (c.e && c.e.hw) || {};
    if (c.famId === 'yard') return 'Steel H-stake' + (hw.w && hw.h ? ', ' + fmt(hw.w) + ' x ' + fmt(hw.h) + ' in' : '');
    if (c.famId === 'aframe') return 'Steel A-frame and zip ties' + (c.flag ? ', with the pennant flag' : '');
    if (c.famId === 'post') return (hw.post ? hw.post.replace(/\s*\(.*$/, '').toLowerCase().replace(/^./, function (x) { return x.toUpperCase(); }) : 'Post') + ': PVC post, arm and ground stake';
    if (c.famId === 'frame') return 'Steel frame' + (hw.w && hw.h ? ', ' + fmt(hw.w) + ' x ' + fmt(hw.h) + ' in' : '');
    return '';
  }
  function matLabel(c) { return (c.sign && c.sign.geo.material) || ''; }
  // every supplier option group shown for this product, in their order and wording (written on the order as "Options")
  function optLines(c) {
    var out = [];
    c.fam.groups.forEach(function (g) {
      if (c.sel[g.id] == null || !shows(g.when, c.sel)) return;
      var v = valOf(g, c.sel[g.id]); if (!v) return;
      out.push([g.label || 'Order', v.label]);
    });
    return out;
  }
  function optText(c) { return optLines(c).map(function (l) { return l[0] + ': ' + l[1]; }).join('; '); }
  function qtyNoun(c, n) { return c.pack > 1 ? (n === 1 ? 'pack' : 'packs') : (n === 1 ? 'sign' : 'signs'); }
  function qtyLabel(n, c) { c = c || cfg(); return n + ' ' + qtyNoun(c, n) + (c.pack > 1 ? ' of ' + c.pack + ' (' + (n * c.pack) + ' signs)' : ''); }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Free shipping anywhere in the US'; }
  function faceName(f) { return { front: 'Sign front', back: 'Sign back', 'rider-front': 'Rider front', 'rider-back': 'Rider back' }[normFace(f)]; }
  function frontLabel(c) { return c.sides === 2 && c.bm.sign !== 'different' ? 'Sign front (same art on the back)' : (c.rider || c.sides === 2 ? 'Sign front' : 'Sign'); }
  function proofFaceLabel(c, f) {
    if (f === 'front') return frontLabel(c);
    if (f === 'back') return 'Sign back (as seen from the back)';
    if (f === 'rider-front') return c.rsides === 2 && c.bm.rider !== 'different' ? 'Rider front (same art on the back)' : 'Rider front';
    return 'Rider back (as seen from the back)';
  }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new sign or rider size: keep the art, but fit it to the new template (Fill for pictures, Fit for files)
  function resetArt(piece) {
    FACES.forEach(function (f) { var a = ART[f]; if (a && pieceOf(f) === piece) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } });
  }
  function viewFor() { return S.back ? 'back' : 'front'; }
  // after a change: a rider face needs a rider, a back needs a 2-sided piece
  function fixFace() {
    var c = cfg();
    if (S.piece === 'rider' && !c.rider) { S.piece = 'sign'; S.face = 'front'; S.back = false; c = cfg(); }
    if (S.face === 'back' && c.pieceSides !== 2) { S.face = 'front'; S.back = false; }
  }
  // a new product: its first sign size
  function pickFamily(id) {
    var f = famOf(id), c = cfg(); if (!f.id || f.id === c.famId) return;
    var ks = keysShown(f); if (!ks.length) return;
    pickSign(ks[0], f.id);
  }
  // a new sign size (or product): keep the art, fit it again when the page changes
  function pickSign(key, famId) {
    key = normKey(key); if (!key) return;
    var c = cfg(); if (key === c.key) return;
    var a = KEYS[c.key], b = KEYS[key];
    var same = a && b && +a.sign.W === +b.sign.W && +a.sign.H === +b.sign.H;
    if (!same) { resetArt('sign'); if (S.piece === 'sign') { lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; } }
    var rBefore = c.riderSize;
    Object.assign(S, { key: key, fam: famId || b.fam, artVer: S.artVer + 1 });
    var c2 = cfg();
    if (c2.riderSize !== rBefore && c2.riderSize) resetArt('rider');
    fixFace(); render();
    view3d(viewFor());
  }
  // a supplier option: keep every other pick that still applies
  function pickOpt(gid, v) {
    var c = cfg(); if (c.sel[gid] === v) return;
    var sel = Object.assign({}, S.sel, c.sel); sel[gid] = v;
    var rBefore = c.riderSize, sBefore = c.sides;
    Object.assign(S, { sel: sel, artVer: S.artVer + 1 });
    var c2 = cfg();
    if (c2.riderSize && c2.riderSize !== rBefore) {
      resetArt('rider');
      toast('Rider added. Pick "Rider" on the layout toolbar to design it.');
    }
    if (sBefore === 2 && c2.sides !== 2) S.backMode = 'same';
    fixFace(); render();
    view3d(viewFor());
  }
  // a new pack size keeps about the same number of signs (3 single signs -> 1 pack of 5; 2 packs of 25 -> 5 packs of 10)
  function pickPack(q) { q = +q; if (!q || q === S.pack) return; var c = cfg(), signs = c.qty * c.pack; set({ pack: q, qty: Math.max(1, Math.min(maxQty(q), Math.ceil(signs / q))) }); }
  function setQty(n) { n = Math.max(1, Math.min(maxQty(cfg().pack), Math.round(Number(n)) || 1)); if (n !== S.qty) set({ qty: n }); else render(); }
  // the back of a 2-sided piece: the same art as its front, or its own (piece: 'sign' | 'rider', default the piece shown)
  function pickBackMode(mode, piece) {
    var p = piece === 'rider' || piece === 'sign' ? piece : S.piece;
    var cur = p === 'rider' ? S.rBackMode : S.backMode;
    if (mode === cur) { if (mode === 'different' && (S.piece !== p || S.face !== 'back')) { S.piece = p; S.face = 'back'; S.back = true; render(); view3d('back'); } return; }
    var patch = { artVer: S.artVer + 1, piece: p };
    patch[p === 'rider' ? 'rBackMode' : 'backMode'] = mode;
    if (mode === 'different') { patch.face = 'back'; patch.back = true; } // go straight to the back so its art can be added
    else { patch.face = 'front'; patch.back = false; }
    set(patch);
    view3d(S.back ? 'back' : 'front');
  }
  // show (and edit) a face: switches the piece and side; false when this order has no such face
  function goFace(face) {
    var f = normFace(face), p = pieceOf(f), c = cfg();
    if (p === 'rider' && !c.rider) return false;
    var sides = p === 'rider' ? c.rsides : c.sides;
    if (isBack(f) && sides !== 2) return false;
    if (p !== S.piece) { lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; }
    set({ piece: p, face: isBack(f) ? 'back' : 'front', back: isBack(f) });
    view3d(viewFor());
    return true;
  }

  // ---------- artwork ----------
  // the art drawn on a face: a back with "Same as front" shows its piece's front art
  function backShown(p) { var c = cfg(), sd = p === 'rider' ? c.rsides : c.sides; return sd === 2 && c.bm[p] === 'different'; }
  function artFor(face) {
    var p = pieceOf(face);
    if (isBack(face) && backShown(p)) return ART[fid(p, 'back')];
    return ART[fid(p, 'front')];
  }
  // v2: text, clipart and logo layers added in the designer (ardor-realestate-layers-kit.js). Same face rule as artFor.
  function layerFace(face) { var p = pieceOf(face); return isBack(face) && backShown(p) ? fid(p, 'back') : fid(p, 'front'); }
  function hasLayers(f) { return !!(window.ArdorRealestateLayers && window.ArdorRealestateLayers.has(normFace(f))); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // Oct 12, 2026 (tpl): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and the
  // request holds the proof, the print file(s) and the customer's original upload(s). Keep the whole upload under
  // UPLOAD_BUDGET: print files first (made smaller when needed), then the proof, then the original files while they fit.
  // Same approach as assets/ardor-aframe-builder-v2-v2.js.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor Real Estate Sign Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print file for one face again, as one flattened image of at most maxBytes (same path as faces with text or clipart)
  function smallerPrint(c, face, a, maxBytes, approval) {
    var P = window.ArdorRealestatePDF, LY = window.ArdorRealestateLayers, Wi = c.Wi, Hi = c.Hi;
    if (!P || !P.buildPrint || !LY || !LY.composite) return Promise.reject(new Error('print tools not loaded'));
    var stamp = (approval && approval.when) || stampLabel(new Date());
    return LY.composite(face, Wi, Hi, a).then(function (r) { return shrinkImage(r.file, maxBytes - 65536); }).then(function (file) {
      return P.buildPrint({ title: 'Ardor Real Estate Sign Print File', stamp: stamp, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125,
        faces: [{ art: { file: file, name: file.name, kind: 'image', bg: '#FFFFFF' }, bg: '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } }] }, false);
    }).then(function (r) { return r && r.blob; });
  }
  function fitUpload(c, files, approval) {
    var faces = printedFaces(c);
    var size = function (b) { return b ? b.size : 0; };
    files.skipArt = {}; files.needEmail = false;
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var prints = function () { return faces.reduce(function (t, f) { return t + size(files[f]); }, 0); };
    var total = function () { return size(files.proof) + prints() + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
    // 1. each print file gets an equal share of what the proof leaves
    var share = Math.max(1572864, Math.floor((UPLOAD_BUDGET - size(files.proof) - 262144) / faces.length));
    var chain = Promise.resolve();
    faces.forEach(function (f) {
      chain = chain.then(function () {
        var bl = files[f]; if (!bl || bl.size <= share) return null;
        return smallerPrint(cfg({ piece: pieceOf(f) }), f, ART[f], share, approval).then(function (nb) {
          if (nb && nb.size < bl.size) {
            files[f] = nb;
            files.notes.push('The ' + faceName(f).toLowerCase() + ' print file was made at a lower resolution (' + fmtMB(bl.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
          }
        }, function () { return null; });
      });
    });
    return chain.then(function () {
      // 2. the customer's original files, while they still fit
      var used = size(files.proof) + prints();
      faces.forEach(function (f) {
        var o = orig(f); if (!o) return;
        if (used + o.size <= UPLOAD_BUDGET) { used += o.size; return; }
        files.skipArt[f] = true;
        if (!files[f]) files.needEmail = true;
        files.notes.push('The customer\'s original ' + faceName(f).toLowerCase() + ' file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files[f] ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      // 3. last resort: a print file that could not be made small enough stays out
      faces.slice().reverse().forEach(function (f) {
        if (total() <= UPLOAD_BUDGET || !files[f]) return;
        files.notes.push('The ' + faceName(f).toLowerCase() + ' print file (' + fmtMB(files[f].size) + ') was too large to attach. Make it from the original artwork.');
        files[f] = null;
        if (files.skipArt[f] || !orig(f)) files.needEmail = true;
      });
      return files;
    });
  }
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorRealestateLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorRealestateLayers; if (!LY || !LY.list) return '';
    var keys = printedFaces(c);
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? faceName(k) + ': ' : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  // art turned 90 or 270 degrees: its box is as wide as the picture is tall
  function rot90(a) { return !!a && (a.rot === 90 || a.rot === 270); }
  function geom(a, Wi, Hi) {
    var ia = rot90(a) ? a.natH / a.natW : a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW, rot: a.rot || 0 };
  }
  // draw a picture into its placed box g (the box of the art as turned), turned g.rot degrees clockwise
  function drawRot(ctx, img, g) {
    if (!g.rot) { ctx.drawImage(img, g.x, g.y, g.w, g.h); return; }
    var q = g.rot === 90 || g.rot === 270, dw = q ? g.h : g.w, dh = q ? g.w : g.h;
    ctx.save();
    ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
    ctx.rotate(g.rot * Math.PI / 180);
    ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorRealestateLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      drawRot(ctx, a.img, g);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorRealestateLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor Real Estate Sign Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // A file added while a Back tab shows "Same as front" is art for that back, so the piece switches to "Different back".
  // Returns the face id the file goes on.
  function uploadFace(file) {
    var c = cfg(), p = c.piece;
    if (S.face !== 'back') return fid(p, 'front');
    if (file && file.size <= MAX_FILE && c.pieceSides === 2 && c.bm[p] !== 'different') {
      if (p === 'rider') S.rBackMode = 'different'; else S.backMode = 'different';
      S.back = true; S.artVer++;
      toast('This art goes on the back. The front keeps its own art.');
    }
    return fid(p, 'back');
  }

  // Oct 12 (tpl): a finished template file (made on the template page of this face, so it has the page's shape within TPL_TOL)
  // is placed edge to edge on the whole page, bleed included, unturned
  var TPL_TOL = 0.01;
  function tplFit(a, face) {
    var c = cfg({ piece: pieceOf(face) });
    if (!a || !a.img || !(a.natW > 0) || !(a.natH > 0) || !(c.Wi > 0) || !(c.Hi > 0)) return false;
    if (Math.abs((a.natW / a.natH) / (c.Wi / c.Hi) - 1) > TPL_TOL) return false;
    a.mode = 'fill'; a.rot = 0; a.rcx = 0.5; a.rcy = 0.5; a.tpl = true;
    if (!/^ardor-ai-/.test(a.name || '')) toast('Template file detected - placed edge to edge'); // AI designs are page-sized too
    return true;
  }
  // Oct 20 2026 (upload bug): uploaded artwork is painted UNDER the layers (paintFace), so on a face that holds a
  // template or a Background layer (fabric.ArdorBg, full page, opaque) a new upload was completely hidden: on screen,
  // in 3D, on the proof and in the print file. how = 'ask' (customer uploads: file input, drop): the kit asks first
  // (add it as a logo layer on top, or replace the template); how = 'replace': the kit takes the template off this
  // face, then the file becomes its artwork as before; any other caller (AI designs: whole-sign pictures) replaces
  // the template with a message. Faces without a template or background: unchanged.
  function loadFile(file, face, how) {
    face = normFace(face);
    var err = $('[data-abb-error]');
    if (!file) return;
    var KT = window.ArdorRealestateKit, over = file && file.size <= MAX_FILE && KT && KT.designFor ? KT.designFor(face) : null;
    if (over && how === 'ask' && KT.askUpload) {
      KT.askUpload({ file: file, face: face, preview: function () { return loadArtView().then(function (av) { return av.preview(file, { maxPx: 2400 }); }); }, replace: function () { loadFile(file, face, 'replace'); } });
      return;
    }
    if (over && KT.clearDesign) KT.clearDesign(face, how === 'replace' ? 'ask' : 'ai');
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF', rot: 0 };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a);
      ART[face] = a; tplFit(a, face); S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      var fk = FACES.filter(function (k) { return ART[k] === a; })[0]; if (fk) { tplFit(a, fk); S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your sign, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your sign.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your sign.' + tail;
  }
  function needsEmailProof() {
    return printedFaces(cfg()).some(function (f) { var x = ART[f]; return x && x.noPreview; });
  }

  // ---------- flat sign drawing (2D editor, 3D faces and proof) ----------
  function polyPath(ctx, p) { if (!p || !p.length) return; ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.closePath(); }
  var checkerCv = null;
  function checker(ctx, u) {
    try {
      if (!checkerCv) {
        checkerCv = document.createElement('canvas'); checkerCv.width = checkerCv.height = 16;
        var x = checkerCv.getContext('2d'); x.fillStyle = '#ECECEF'; x.fillRect(0, 0, 16, 16); x.fillStyle = '#DADADF'; x.fillRect(0, 0, 8, 8); x.fillRect(8, 8, 8, 8);
      }
      var pat = ctx.createPattern(checkerCv, 'repeat');
      if (pat && pat.setTransform && window.DOMMatrix) { pat.setTransform(new DOMMatrix().scale(u * 0.75)); return pat; }
    } catch (e) {}
    return '#E6E6EA';
  }
  // a label centered in a box, at least about 9 screen pixels high, shrunk to fit the box's width
  function zoneLabel(ctx, txt, x, y, w, h, u) {
    if (!txt) return;
    var turn = h > w * 2.5, L = turn ? h : w, T = turn ? w : h;
    if (T / u < 6) return; // thinner than 6 screen pixels: no room for a label
    ctx.save();
    ctx.font = '700 1px Arial, sans-serif';
    var tw = ctx.measureText(txt).width || txt.length * 0.6;
    var fs = Math.max(Math.min(T * 0.5, (L * 0.86) / tw, 3), u * 9);
    if (tw * fs > L * 0.98) fs = (L * 0.98) / tw;
    if (fs / u < 6) { ctx.restore(); return; }
    ctx.translate(x + w / 2, y + h / 2); if (turn) ctx.rotate(-Math.PI / 2);
    ctx.font = '700 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round'; ctx.lineWidth = fs * 0.28; ctx.strokeStyle = 'rgba(30,31,36,0.85)'; ctx.strokeText(txt, 0, 0);
    ctx.fillStyle = 'rgba(255,255,255,0.96)'; ctx.fillText(txt, 0, 0);
    ctx.restore();
  }
  // the guides on one face: outside the visible area dimmed, the zones the hardware covers greyed and labelled (frame
  // lip, clips, rider clamp, grommets), the keep-clear zones around hanging holes hatched, the holes drawn, the visible
  // area's edge and the dashed red safe line. u = inches per screen pixel (line widths).
  function drawGuides(ctx, c, Wi, Hi, face, u) {
    var G = faceGeo(c, face), v = G.vis;
    ctx.save();
    ctx.setLineDash([]);
    if (v.x > 0.001 || v.y > 0.001 || v.w < Wi - 0.002 || v.h < Hi - 0.002) {
      ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.rect(v.x, v.y, v.w, v.h);
      ctx.globalAlpha = 0.55; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    }
    G.hidden.forEach(function (z) {
      ctx.fillStyle = 'rgba(52,54,62,0.62)'; ctx.fillRect(z.x, z.y, z.w, z.h);
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(255,255,255,0.45)'; ctx.strokeRect(z.x, z.y, z.w, z.h);
    });
    var said = {};
    G.hidden.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; }).forEach(function (z) {
      var t = String(z.why || 'Hidden').toUpperCase(); if (said[t]) return; said[t] = 1;
      zoneLabel(ctx, t, z.x, z.y, z.w, z.h, u);
    });
    G.keep.forEach(function (z) {
      ctx.save(); ctx.beginPath(); ctx.rect(z.x, z.y, z.w, z.h); ctx.clip();
      ctx.fillStyle = 'rgba(52,54,62,0.14)'; ctx.fillRect(z.x, z.y, z.w, z.h);
      ctx.beginPath(); var st = Math.max(u * 6, 0.12);
      for (var hx = z.x - z.h; hx < z.x + z.w; hx += st) { ctx.moveTo(hx, z.y + z.h); ctx.lineTo(hx + z.h, z.y); }
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(52,54,62,0.4)'; ctx.stroke(); ctx.restore();
    });
    if (G.bleed > 0) {
      ctx.beginPath(); ctx.rect(G.trim.x, G.trim.y, G.trim.w, G.trim.h);
      ctx.setLineDash([u * 3, u * 3]); ctx.lineWidth = u * 1.2; ctx.strokeStyle = 'rgba(12,13,13,0.75)'; ctx.stroke(); ctx.setLineDash([]);
    }
    ctx.beginPath(); ctx.rect(v.x, v.y, v.w, v.h);
    ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    G.holes.forEach(function (h) {
      var r = Math.max(h[2] / 2, u * 3.5);
      ctx.beginPath(); ctx.arc(h[0], h[1], r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,0.95)'; ctx.fill();
      ctx.lineWidth = Math.max(u * 1.6, r * (G.holeKind === 'grommet' ? 0.55 : 0.3)); ctx.strokeStyle = 'rgba(70,72,80,0.95)'; ctx.stroke();
    });
    G.safe.forEach(function (p) {
      ctx.beginPath(); polyPath(ctx, p);
      ctx.setLineDash([]); ctx.lineWidth = u * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)'; ctx.stroke();
      ctx.setLineDash([u * 6, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)'; ctx.stroke();
    });
    ctx.setLineDash([]);
    ctx.restore();
  }
  function drawFlat(ctx, c, Wi, Hi, face, guides, u) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, face), tall = G.bh > G.bw * 1.6;
      ctx.save();
      ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2);
      if (tall) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork goes here', 0, 0);
      ctx.restore();
    }
    if (!guides) return;
    drawGuides(ctx, c, Wi, Hi, face, u || Math.max(Wi, Hi) / 600);
  }

  // ---------- flat layout editor: the whole template fits the stage; zoom in and pan to work on part of it ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the page's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole page, lay.cx / lay.cy = the view's center in page fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 1, cx: 0.5, cy: 0.5, ox: 0, oy: 0 };
  var ZMAX = 8;
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 520;
    var fit = Math.min(maxW / Wi, maxH / Hi), z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    drawFlat(ctx, c, Wi, Hi, fid(c.piece, S.face), true, 1 / z);
    syncZoomUi();
    try { root.dispatchEvent(new CustomEvent('ardor:realestate-view')); } catch (e) {}
  }
  function syncZoomUi() {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= ZMAX - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole page); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, ZMAX);
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  // turn the art on the face being edited 90 degrees (d = 90 right, -90 left) around its center, keeping its size
  function rotateArt(d) {
    var a = editingArt(); if (!a || !a.img) return;
    var c = cfg(), g = geom(a, c.Wi, c.Hi);
    a.rot = (((a.rot || 0) + d) % 360 + 360) % 360;
    if (a.mode === 'custom') a.rw = g.h / c.Wi;
    S.artVer++; render();
  }

  function editingArt() { var c = cfg(); return S.face === 'back' ? (c.pieceSides === 2 && c.backMode === 'different' ? ART[fid(c.piece, 'back')] : null) : ART[fid(c.piece, 'front')]; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    // drag the art to move it. Zoomed in: drag outside the art (or with the hand tool on) to move the view.
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(), c = cfg(), zoomed = lay.zoom > 1.001, onArt = false;
      if (a && a.img && !lay.hand) {
        if (!zoomed) onArt = true;
        else {
          var g = geom(a, c.Wi, c.Hi), r = cv.getBoundingClientRect();
          var ux = (e.clientX - r.left - lay.ox) / lay.scale, uy = (e.clientY - r.top - lay.oy) / lay.scale;
          onArt = ux >= g.x && ux <= g.x + g.w && uy >= g.y && uy <= g.y + g.h;
        }
      }
      if (!onArt && !zoomed) return;
      lay.drag = onArt; lay.pan = !onArt; lay.lx = e.clientX; lay.ly = e.clientY;
      if (lay.pan) cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (lay.pan) { var px = e.clientX - lay.lx, py = e.clientY - lay.ly; lay.lx = e.clientX; lay.ly = e.clientY; panBy(px, py); return; }
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { var was = lay.pan; lay.drag = false; lay.pan = false; if (was) syncZoomUi(); };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    // mouse wheel / trackpad over the stage: pinch or Ctrl + wheel zooms, the wheel moves the view when zoomed in
    cv.parentNode.addEventListener('wheel', function (e) {
      var r = cv.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.pow(0.996, e.deltaY), px, py); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault();
      panBy(-(e.shiftKey ? e.deltaY : e.deltaX), -(e.shiftKey ? 0 : e.deltaY));
    }, { passive: false });
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    on('[data-abb-rot-l]', 'click', function () { rotateArt(-90); });
    on('[data-abb-rot-r]', 'click', function () { rotateArt(90); });
    on('[data-abb-zoom2d-in]', 'click', function () { setZoom(lay.zoom * 1.5); });
    on('[data-abb-zoom2d-out]', 'click', function () { setZoom(lay.zoom / 1.5); });
    on('[data-abb-zoom2d-fit]', 'click', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on('[data-abb-hand]', 'click', function () { lay.hand = !lay.hand; syncZoomUi(); });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  function resIssue(a, c) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, c.Wi, c.Hi), ppi = Math.round(a.natW / (rot90(a) ? g.h : g.w));
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or pick a smaller sign.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    fixFace();
    var c = cfg();
    var two = c.pieceSides === 2, backDiff = two && c.backMode === 'different';
    var a = editingArt();
    var tabs = $('[data-abb-art-tabs]'); if (tabs) tabs.hidden = !two && !c.rider;
    $$('[data-abb-piece]').forEach(function (pb) { pb.hidden = !c.rider; pb.setAttribute('aria-pressed', pb.getAttribute('data-abb-piece') === c.piece ? 'true' : 'false'); });
    $$('[data-abb-face]').forEach(function (fb) { fb.hidden = !two; fb.setAttribute('aria-pressed', fb.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var lab = c.rider ? (c.piece === 'rider' ? 'rider ' : 'sign ') : '';
    var sameBack = S.face === 'back' && !backDiff;
    $('[data-abb-drop]').hidden = sameBack;
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = S.face === 'back' ? 'Upload art for the ' + lab + 'back' : (c.piece === 'rider' ? 'Upload rider artwork' : 'Upload artwork');
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (sameBack) { empty.hidden = false; empty.textContent = 'The ' + lab + 'back shows the same art as the ' + lab + 'front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the sign will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.face === 'back' ? 'No art for the ' + lab + 'back yet. Upload it above.' : (c.piece === 'rider' ? 'No rider artwork yet. Upload yours above.' : 'No artwork yet. Upload yours above.'); }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
    }
    // image resolution on every printed face; the worst one is shown, in the footer, where it is always in view
    var faces = printedFaces(c), worst = null;
    faces.forEach(function (f) {
      var r = resIssue(ART[f], cfg({ piece: pieceOf(f) }));
      if (r && (!worst || (r.level === 'bad' && worst.r.level !== 'bad'))) worst = { f: f, r: r };
    });
    if (worst) { msg = (faces.length > 1 ? 'The image for the ' + faceName(worst.f).toLowerCase() : 'This image') + worst.r.text; level = worst.r.level; }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
  }

  // ---------- render ----------
  function specLines(c) {
    var out = [['Product', productLabel(c)], ['Size', sizeLabel(c)], ['Sides', sidesLabel(c)], ['Order', orderLabel(c)]];
    if (c.fam.groups.some(function (g) { return g.role === 'rider'; })) out.push(['Rider', riderLabel(c)]);
    var hw = hwLabel(c); if (hw) out.push(['Stake/Hardware', hw]);
    var mn = matLabel(c); if (mn) out.push(['Material', mn]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    return out;
  }
  // small product icons for the product cards (24 x 40)
  var SIL = {
    yard: '<rect x="2" y="6" width="20" height="15" rx="1" fill="currentColor" opacity=".85"/><path d="M8 21v16M16 21v16M8 29h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    aframe: '<path d="M6 4l-4 34M18 4l4 34M5 4h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><rect x="5" y="7" width="14" height="11" rx="1" fill="currentColor" opacity=".85"/>',
    post: '<path d="M4 3v35M4 6h19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><rect x="8" y="9" width="14" height="11" rx="1" fill="currentColor" opacity=".85"/><rect x="8" y="3" width="14" height="2" fill="currentColor" opacity=".6"/>',
    frame: '<rect x="4" y="3" width="16" height="22" rx="1" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="6" y="5" width="12" height="10" fill="currentColor" opacity=".85"/><rect x="6" y="17" width="12" height="4" fill="currentColor" opacity=".6"/><path d="M6 25v13M18 25v13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
  };
  function famIcon(id) {
    return '<svg class="abb-opt__sil" viewBox="0 0 24 40" width="22" height="36" aria-hidden="true" focusable="false">' + (SIL[id] || SIL.yard) + '</svg>';
  }
  // a short help line under a supplier option group
  function groupNote(c, g) {
    if (g.role === 'size') return c.famId === 'post' ? 'Small post: 24 in wide signs. Large post: 36 in wide signs.' : '';
    if (g.role === 'order') return c.order === 'GO' ? 'Sign only: a new printed sign for hardware you already have.' : (c.famId === 'post' ? hwLabel(c) + '.' : 'The sign with its hardware: ' + hwLabel(c).replace(/^./, function (x) { return x.toLowerCase(); }) + '.');
    if (g.role === 'sides') return c.sides === 2 ? 'Printed on the front and the back. Use the same art on both sides, or give the back its own.' : 'Printed on the front.';
    if (g.role === 'rider') return c.rider ? 'The rider is its own printed piece (' + pieceSize(c.rider.geo) + ', ' + (c.rsides === 2 ? 'double sided' : 'single sided') + '). Pick "Rider" on the layout toolbar to design it.' : '';
    if (g.role === 'flag') return c.flag ? 'A red Open House pennant flag and pole come with the frame.' : '';
    return '';
  }
  // a bigger pack that costs the same as this order or less: say so, with a one-click switch (prices stay the store's own)
  function packNudge(c, p) {
    // it sits right under the quantity note (the app layout moves that note into its quantity row, so follow it there)
    var qn = $('[data-abb-qty-note]'), el = $('[data-abb-pack-nudge]');
    if (!qn || !qn.parentNode) return;
    if (!el) { el = document.createElement('div'); el.className = 'abb-pack-nudge'; el.setAttribute('data-abb-pack-nudge', ''); el.setAttribute('role', 'status'); }
    if (qn.nextSibling !== el) qn.parentNode.insertBefore(el, qn.nextSibling);
    var signs = c.qty * c.pack, now = Math.round(p.charged * 100), best = 0, bestCents = 0;
    if (c.packs.length > 1) c.packs.slice().sort(function (a, b) { return a - b; }).forEach(function (q) {
      if (best || q === c.pack || q < signs) return;
      var v = variantFor(c.key, c.combo, q);
      if (v.cents > 0 && v.cents <= now) { best = q; bestCents = v.cents; }
    });
    el.textContent = '';
    el.hidden = !best;
    if (!best) return;
    var what = c.pack > 1 ? c.qty + ' ' + (c.qty === 1 ? 'pack' : 'packs') + ' of ' + c.pack : c.qty + ' single ' + (c.qty === 1 ? 'sign' : 'signs'), more = best - signs;
    var t = document.createElement('span'); t.className = 'abb-pack-nudge__txt';
    t.textContent = 'A pack of ' + best + ' is ' + money(bestCents / 100) + (bestCents < now ? ', less than ' : ', the same as ') + what + ' (' + money(p.charged) + ')' + (more > 0 ? ', and you get ' + more + ' more ' + (more === 1 ? 'sign' : 'signs') : '') + '.';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'abb-pack-nudge__btn'; b.setAttribute('data-abb-pack-switch', String(best));
    b.textContent = 'Switch to the ' + best + '-pack';
    b.addEventListener('click', function () { set({ pack: best, qty: 1 }); toast('Switched to a pack of ' + best + ' signs: ' + money(bestCents / 100) + '.'); });
    el.appendChild(t); el.appendChild(b);
  }
  function renderGroup(slot, c, g) {
    var vis = shows(g.when, c.sel);
    slot.hidden = !vis;
    slot.setAttribute('data-abb-group', g.id);
    var tEl = $('[data-abb-opt-title]', slot); if (tEl) tEl.textContent = g.label || (g.role === 'order' ? 'Order' : 'Option');
    // the option list and its note are found by the slot number: the app layout moves them into its option rows
    var idx = slot.getAttribute('data-abb-optstep'), box = $('[data-abb-opt="' + idx + '"]'), note = $('[data-abb-opt-note="' + idx + '"]');
    if (!box) return;
    if (!vis) { fill(box, []); if (note) note.textContent = ''; return; }
    var vals = realVals(g).filter(function (v) { return g.role === 'size' ? (v.key && keysShown(c.fam).indexOf(v.key) >= 0) : valShows(c.key, g, v, c.sel); });
    var single = vals.length < 2, nodes = [];
    g.values.forEach(function (v) {
      if (v.hdr) { if (!single) { var h = document.createElement('span'); h.className = 'abb-opt-hdr'; h.textContent = v.label; nodes.push(h); } return; }
      if (vals.indexOf(v) < 0) return;
      var on, cents, data, pick;
      if (g.role === 'size') { on = v.key === c.key; cents = priceForKey(c, v.key); data = ['sign', v.key]; pick = function () { pickSign(v.key); }; }
      else { on = c.sel[g.id] === v.v; cents = priceWith(c, g, v); data = [g.id, v.v]; pick = function () { pickOpt(g.id, v.v); }; }
      var html = '<span class="abb-opt__name">' + esc(v.label) + '</span>' + (single ? '' : '<span class="abb-opt__price">' + (cents > 0 ? money(cents / 100) : 'Call us') + '</span>');
      var b = optBtn({ chip: single, on: on, data: data, disabled: !single && !(cents > 0), html: html, pick: pick });
      if (g.role === 'size') b.setAttribute('data-size', v.v);
      nodes.push(b);
    });
    slot.classList.toggle('abb-step--fixed', single);
    box.className = 'abb-opts ' + (single ? 'abb-opts--chips' : (g.role === 'size' ? 'abb-opts--cards abb-opts--sizes' : 'abb-opts--two'));
    fill(box, nodes);
    if (note) note.textContent = groupNote(c, g);
  }

  function render() {
    var c = cfg();
    var p = price(c);
    S.fam = c.famId; S.key = c.key;

    // 1. product: one card per product with its icon and its lowest price
    fill($('[data-abb-shapes]'), famsShown().map(function (f) {
      var lo = famFrom(f);
      var html = famIcon(f.id) + '<span class="abb-opt__name">' + esc(f.name).replace(/(\S+-\S+)/g, '<span class="abb-nw">$1</span>') + '</span><span class="abb-opt__sub">' + esc(f.sub || '') + '</span><span class="abb-opt__price">' + (lo > 0 ? 'from ' + money(lo / 100) : 'Call us') + '</span>';
      return optBtn({ on: f.id === c.famId, html: html, data: ['fam', f.id], pick: function () { pickFamily(f.id); } });
    }));

    // 2. the supplier's option groups for this product, in their order and wording (one slot each)
    var slots = $$('[data-abb-optstep]'), gi = 0;
    c.fam.groups.forEach(function (g) { var slot = slots[gi++]; if (slot) renderGroup(slot, c, g); });
    for (; gi < slots.length; gi++) { var ix = slots[gi].getAttribute('data-abb-optstep'), nt = $('[data-abb-opt-note="' + ix + '"]'); slots[gi].hidden = true; slots[gi].removeAttribute('data-abb-group'); fill($('[data-abb-opt="' + ix + '"]'), []); if (nt) nt.textContent = ''; }

    // 3. backs: the same art as the front, or a different back (the sign, and the rider when it has 2 sides)
    var bWrap = $('[data-abb-sides-wrap]'); if (bWrap) bWrap.hidden = !(c.sides === 2 || c.rsides === 2);
    var sBox = $('[data-abb-sides]'); if (sBox) { sBox.hidden = true; fill(sBox, []); }
    setText('[data-abb-sides-note]', c.sides === 2 || c.rsides === 2 ? 'Each 2-sided piece can show the same art on both sides, or a different back.' : '');
    var bmWrap = $('[data-abb-backmode-wrap]'); if (bmWrap) bmWrap.hidden = c.sides !== 2;
    fill($('[data-abb-backmodes]'), c.sides === 2 ? [
      optBtn({ chip: true, on: c.bm.sign !== 'different', data: ['backmode', 'same'], label: 'Same as front', pick: function () { pickBackMode('same', 'sign'); } }),
      optBtn({ chip: true, on: c.bm.sign === 'different', data: ['backmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different', 'sign'); } })
    ] : []);
    var rbWrap = $('[data-abb-rbackmode-wrap]'); if (rbWrap) rbWrap.hidden = c.rsides !== 2;
    fill($('[data-abb-rbackmodes]'), c.rsides === 2 ? [
      optBtn({ chip: true, on: c.bm.rider !== 'different', data: ['rbackmode', 'same'], label: 'Same as front', pick: function () { pickBackMode('same', 'rider'); } }),
      optBtn({ chip: true, on: c.bm.rider === 'different', data: ['rbackmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different', 'rider'); } })
    ] : []);

    // 4. quantity: packs where the supplier sells packs, then 1 to 100 (signs or packs)
    var pkWrap = $('[data-abb-packs-wrap]'), many = c.packs.length > 1;
    if (pkWrap) pkWrap.hidden = !many;
    fill($('[data-abb-packs]'), many ? c.packs.map(function (q) {
      var v = variantFor(c.key, c.combo, q), each = v.cents / 100;
      return optBtn({ on: q === c.pack, data: ['pack', q], disabled: !(v.cents > 0), html: '<span class="abb-opt__name">' + (q === 1 ? 'Single sign' : 'Pack of ' + q) + '</span><span class="abb-opt__price">' + (v.cents > 0 ? money(each) : 'Call us') + '</span>' + (q > 1 && v.cents > 0 ? '<span class="abb-opt__sub">' + money(each / q) + ' each</span>' : ''), pick: function () { pickPack(q); } });
    }) : []);
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    if (qIn) qIn.setAttribute('aria-label', c.pack > 1 ? 'Number of packs of ' + c.pack + ' signs' : 'Number of signs');
    var qMax = maxQty(c.pack); if (qIn) qIn.max = String(qMax);
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1; if (qp) qp.disabled = c.qty >= qMax;
    setText('[data-abb-qty-unit]', c.pack > 1 ? (c.qty === 1 ? 'pack' : 'packs') + ' of ' + c.pack : (c.qty === 1 ? 'sign' : 'signs'));
    setText('[data-abb-qty-note]', c.pack > 1
      ? 'Quantity counts packs: ' + c.qty + ' ' + (c.qty === 1 ? 'pack' : 'packs') + ' of ' + c.pack + ' = ' + (c.qty * c.pack) + ' signs, ' + money(p.each) + ' per pack' + (c.qty > 1 ? ', ' + money(p.charged) + ' in all' : '') + '. All signs in an order have the same art.'
      : (c.qty > 1 ? c.qty + ' signs at ' + money(p.each) + ' each: ' + money(p.charged) + '. All signs have the same art.' : money(p.each) + ' per sign. All signs in an order have the same art.'));
    packNudge(c, p);

    // 5. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping anywhere in the US</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then quantity x price
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2;
    eachEl.textContent = qtyLabel(c.qty, c) + ' x ' + money(p.each);
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping anywhere in the US';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.');
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = c.delivery === 'pickup' ? 'Free pickup' : 'Free shipping'; });

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', sizeName(c.key) + ' ' + (c.fam.short || 'sign'));
    setText('[data-abb-chip-mat]', (c.sides === 2 ? 'Double sided' : 'Single sided') + (c.rider ? ' + rider' : ''));
    setText('[data-abb-chip-sides]', c.order === 'GO' ? qtyLabel(c.qty, c) + ' (sign only)' : qtyLabel(c.qty, c));
    var G = c.geo, tip = 'Keep text and logos inside the red line.';
    var grom = G.holes.length > 0 && G.holeKind === 'grommet';
    if (G.hidden.some(function (z) { return !(grom && z.k === 'grommet'); })) tip += ' Grey areas are covered by the ' + (c.famId === 'frame' ? 'frame' : 'hardware') + '.';
    if (grom) tip += ' The grey squares are the grommets.';
    else if (G.holes.length) tip += ' Circles are the hanging holes.';
    if (G.flutes) tip += ' The flutes run ' + (G.flutes === 'vertical' ? 'up and down' : 'side to side') + (c.famId === 'yard' ? ' (the H-stake slides into them).' : '.');
    setText('[data-abb-tip]', tip);
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');
    root.setAttribute('data-abb-stand', c.key);
    root.setAttribute('data-abb-piece-on', c.piece);

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorRealestate3D, three.js). Everything else works without it. ----------
  // ---------- 3D viewer (window.ArdorRealestate3D, three.js). Everything else works without it. ----------
  var faceCv = {}, faceSent = {}, engSent = '', syncQueued = false;
  // one face for the 3D view: the whole template page of its piece as printed (the 3D shows what the hardware leaves)
  function paintFaceCanvas(c, face) {
    face = normFace(face);
    if (pieceOf(face) === 'rider' && !c.rider) return null;
    var pc = cfg({ piece: pieceOf(face) }), Wi = pc.Wi, Hi = pc.Hi, k = Math.min(40, 2048 / Math.max(Wi, Hi));
    var w = Math.max(2, Math.round(Wi * k)), h = Math.max(2, Math.round(Hi * k));
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    ctx.setTransform(w / Wi, 0, 0, h / Hi, 0, 0);
    drawFlat(ctx, pc, Wi, Hi, face, false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height + '|' + engSent : 'none|' + engSent;
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv || null);
  }
  function pieceFor3d(g, sides) {
    return { tpl: { w: g.W, h: g.H }, visible: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], hidden: g.hidden.map(function (z) { return { rect: [z.x, z.y, z.w, z.h], why: z.why, kind: z.k }; }),
      faces: sides, holes: g.holes.map(function (h) { return h.slice(); }), flutes: g.flutes || null };
  }
  // the 3D sign gets the product, order, the sign and rider templates (page, visible area, covered zones, holes) and the
  // hardware, then the printed page of each face (backs only on 2-sided pieces: the front art again, or their own art)
  function sync3d() {
    if (!eng) return;
    var c = cfg();
    try {
      var key = [c.key, c.order, c.combo, c.sides, c.riderSize, c.rsides].join('|');
      if (key !== engSent) {
        engSent = key;
        eng.set({ key: c.key, family: c.famId, order: c.order, sign: pieceFor3d(c.sign.geo, c.sides),
          rider: c.rider ? Object.assign(pieceFor3d(c.rider.geo, c.rsides), { size: c.riderSize }) : null,
          hardware: (c.e && c.e.hw) || {}, stake: c.famId === 'yard' && c.order === 'KIT' ? 'h-stake' : null, pennant: !!c.flag });
      }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 ? paintFaceCanvas(c, 'back') : null);
      sendFace('rider-front', c.rider ? paintFaceCanvas(c, 'rider-front') : null);
      sendFace('rider-back', c.rider && c.rsides === 2 ? paintFaceCanvas(c, 'rider-back') : null);
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (!eng || syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorRealestate3D && host) ? window.ArdorRealestate3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
  // one face for the proof: its piece's whole template page with the guides
  function proofCanvas(face, overlayOnly) {
    var fk = normFace(face), c = cfg({ piece: pieceOf(fk) }), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var drewArt = overlayOnly || paintFace(ctx, Wi, Hi, fk);
    if (overlayOnly && hasLayers(layerFace(fk))) window.ArdorRealestateLayers.paint(ctx, Wi, Hi, layerFace(fk));
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, fk);
      ctx.save(); ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2); if (G.bh > G.bw * 1.6) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork', 0, 0); ctx.restore();
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    drawGuides(ctx, c, Wi, Hi, fk, u * 2.4);
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var r = a.rot || 0, ia = rot90(a) ? nh / nw : nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi, rot: r };
      var fw0 = Math.min(Wi, Hi * ia), fh0 = fw0 / ia;
      return { x: (Wi - fw0) / 2, y: (Hi - fh0) / 2, w: fw0, h: fh0, rot: r, note: 'The uploaded PDF is a different shape than the sign template, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, rot: r };
  }

  function loadPdfTool() {
    if (window.ArdorRealestatePDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorRealestatePDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    var turn = a.rot === 90 ? ', turned 90 degrees right' : (a.rot === 270 ? ', turned 90 degrees left' : (a.rot === 180 ? ', turned upside down' : ''));
    if (a.mode === 'fill') return (a.tpl ? 'Template file, placed edge to edge (covered areas included)' : 'Fill the template (edges may crop)') + turn;
    if (a.mode === 'fit') return 'Fit whole image' + turn + ', background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the print page top-left' + turn + ', background ' + a.bg;
  }
  function artName(f) { var a = ART[f]; return a ? a.name : (hasLayers(f) ? 'Text and clipart added in the designer' : ''); }
  function artworkLabel() { return artName('front') || 'None'; }
  function backLabel(p) { p = p === 'rider' ? 'rider' : 'sign'; var bm = p === 'rider' ? S.rBackMode : S.backMode; return bm === 'different' ? (artName(fid(p, 'back')) || 'Different art') : 'Same as front'; }
  // the proof legend: what the guides on this order's templates mean
  function legendText(c) {
    var kinds = [], holes = false, grom = false, keep = false;
    [c.sign.geo].concat(c.rider ? [c.rider.geo] : []).forEach(function (g) {
      var gm = g.holes.length > 0 && g.holeKind === 'grommet';
      g.hidden.forEach(function (z) { if (gm && z.k === 'grommet') return; var t = String(z.why || 'hidden').toLowerCase(); if (kinds.indexOf(t) < 0) kinds.push(t); });
      if (gm) grom = true; else if (g.holes.length) holes = true;
      if (g.keep.length) keep = true;
    });
    var out = kinds.length ? 'Grey areas: covered by the hardware (' + kinds.join(', ') + '). ' : '';
    if (grom) out += 'Grey squares: the grommets. ';
    if (holes) out += 'Circles: the hanging holes. ';
    if (keep) out += 'Hatched squares: keep text clear of the hanging holes. ';
    return out + 'Black line: the visible area. Dashed red line: keep text and logos inside it.';
  }
  function placementFor(f) { var pc = cfg({ piece: pieceOf(f) }); return placementText(ART[f], pc); }
  function printSizeText(c) {
    var t = 'Sign ' + tplTxt(cfg({ piece: 'sign' })) + ' template page per printed side';
    if (c.rider) t += '; rider ' + tplTxt(cfg({ piece: 'rider' })) + ' per printed side';
    return t + ' (no bleed)';
  }
  function proofSpecs(c) {
    var out = specLines(c).filter(function (l) { return l[0] !== 'Delivery' && l[0] !== 'Quantity'; });
    out.push(['Options', optText(c)]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    out.push(['Artwork', artworkLabel()]);
    var pl = placementFor('front'); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel('sign')]);
    if (c.sides === 2 && c.bm.sign === 'different') { var pb = placementFor('back'); if (pb) out.push(['Back placement', pb]); }
    if (c.rider) {
      out.push(['Rider artwork', artName('rider-front') || 'None']);
      var pr = placementFor('rider-front'); if (pr) out.push(['Rider placement', pr]);
      if (c.rsides === 2) out.push(['Rider back', backLabel('rider')]);
      if (c.rsides === 2 && c.bm.rider === 'different') { var prb = placementFor('rider-back'); if (prb) out.push(['Rider back placement', prb]); }
    }
    out.push(['Print size', printSizeText(c)]);
    var added = layerSummary(c); if (added) out.push(['Added in the designer', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
  function proofViews(c) {
    var out = [];
    try { sync3d(); } catch (e) {}
    if (!eng || typeof eng.snapshot !== 'function') return out;
    [['home', 'From the front'], (c.sides === 2 ? ['back', 'From the back'] : ['side', 'From the side'])].forEach(function (v) {
      try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
    });
    return out;
  }
  function proofSheet(P, c, mode, o) {
    var PS = window.ArdorProofSheet;
    if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
    o.noun = c.qty * c.pack > 1 ? 'real estate signs' : 'real estate sign'; o.preview = mode === 'preview'; o.views = proofViews(c);
    return PS.build(o).catch(function () { return P.buildProof(o); });
  }
  function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorRealestatePDF;
      var faces = printedFaces(c);
      var out = { notes: [], proof: null };
      faces.forEach(function (f) { out[f] = null; });
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      // turned PDF/AI art shows on the proof from its drawn preview (the shared proof sheet places vector art unturned)
      var mkProofFace = function (label, f, a) {
        var pc = cfg({ piece: pieceOf(f) }), Wi = pc.Wi, Hi = pc.Hi;
        var va = a && !a.rot ? vectorArt(a) : null;
        return { label: label, canvas: proofCanvas(f, !!va), fallback: va ? proofCanvas(f, false) : null, wIn: Wi, hIn: Hi, wLabel: fmt(Wi) + ' in', hLabel: fmt(Hi) + ' in', underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var pfaces = faces.map(function (f) { return mkProofFace(proofFaceLabel(c, f), f, ART[f]); });
      var date = (approval && approval.when) || stampLabel(new Date());
      var go = c.order === 'GO', many = c.qty * c.pack > 1;
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor Real Estate Sign Proof', panelTitle: (many ? 'Your signs' : 'Your sign') + (go ? ' (sign only)' : ''), sideBySide: false,
          legend: legendText(c) + ' Print pages (width x height): ' + printSizeText(c) + '.',
          approval: approval || null, date: date, faces: pfaces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var printable = function (f) { var a = ART[f]; return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(f); };
      var printP = Promise.resolve();
      // print files: one PDF per printed face, the size of that piece's template page
      // Oct 20 2026: a face that can't be printed (no design yet, or a file with no picture) no longer stops the print
      // files of the other faces, and a face whose print file fails no longer empties the others; each such face gets
      // its own note (the old note blamed "this file type" even for an empty face).
      var printFail = function (f, e) {
        var m = String((e && e.message) || 'error'), a = ART[f], what = a && /\.(pdf|ai)$/i.test(a.name || '') ? 'the uploaded ' + (/\.ai$/i.test(a.name) ? 'AI' : 'PDF') + ' file' : 'the artwork';
        var why = /^filters?\b/.test(m) ? what + ' uses a PDF compression we can\'t re-pack automatically (' + m + ')' : m === 'encrypted' ? what + ' is password protected' : m === 'not a PDF' ? what + ' is not a readable PDF' : 'it could not be made automatically (' + m + ')';
        return 'No print file for the ' + faceName(f).toLowerCase() + ': ' + why + '. Use the original artwork file.';
      };
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ }
      else {
        faces.forEach(function (f) { if (!printable(f)) out.notes.push(ART[f] ? 'No print file for the ' + faceName(f).toLowerCase() + ': we can\'t make a picture of ' + (ART[f].name || 'this file') + '. Use the original artwork file.' : 'No print file for the ' + faceName(f).toLowerCase() + ': it has no design.'); });
        if (faces.some(function (f) { return ART[f] && ART[f].src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        var keep = function (r) { r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); }); return r.blob; };
        var chain = Promise.resolve();
        faces.filter(printable).forEach(function (f) {
          chain = chain.then(function () {
            var pc = cfg({ piece: pieceOf(f) }), Wi = pc.Wi, Hi = pc.Hi;
            // template page size, art to the page edge (covered zones included), no guides. buildPrint takes feet.
            var mkJob = function (a) {
              if (a.rotated && out.notes.indexOf(ROT_NOTE) < 0) out.notes.push(ROT_NOTE);
              return { title: 'Ardor Real Estate Sign Print File', stamp: date, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125, faces: [{ art: a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }] };
            };
            return layerJob(mkJob, ART[f], f, Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r) { out[f] = keep(r); });
          }).catch(function (e) { out[f] = null; out.notes.push(printFail(f, e)); });
        });
        printP = chain;
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; out.faces = faces; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_realestate_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_realestate_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = printedFaces(c).map(function (f) { return [proofFaceLabel(c, f), f, ART[f]]; });
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your real estate sign proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + pieceSizeLabel(c, pieceOf(f[1])) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // One line: the variant (sign size, order, sides / rider / pennant flag and pack), quantity = packs (signs when the pack
  // is 1), everything else as line item properties, including every supplier option in their wording ("Options").
  function setupMsg() { return 'Online ordering for this sign is being set up. Call ' + PHONE + ' or request a quote.'; }

  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    if (c.v.pending) { readLate(c.key, c.combo, c.pack).then(function () { addToCart(); }, function () { showErr(setupMsg()); }); return; }
    if (!p.vid || !c.v.available) { showErr(setupMsg()); return; }
    var faces = printedFaces(c);
    for (var i = 0; i < faces.length; i++) {
      var f = faces[i];
      if (ART[f] || hasLayers(f)) continue;
      goFace(f);
      showErr(f === 'front' ? 'Your sign is blank: upload your artwork, pick a template or add text first.' : (f === 'back' ? 'The back of your sign is blank: add a design, or choose "Same as front".' : (f === 'rider-front' ? 'Your rider is blank: add a design or turn the rider off.' : 'The back of your rider is blank: add a design, or choose "Same as front".')));
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false;
    var waits = FACES.map(function (k) { return ART[k]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof();
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // stay under the cart's 20 MB upload limit
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      specLines(c).forEach(function (l) { fd.append('properties[' + l[0] + ']', l[1]); });
      fd.append('properties[Options]', optText(c));
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel('sign'));
      if (c.rider) { fd.append('properties[Rider artwork]', artName('rider-front') || 'None'); if (c.rsides === 2) fd.append('properties[Rider back]', backLabel('rider')); }
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor Real Estate Sign Designer');
      faces.forEach(function (f) { var pl = placementFor(f); if (pl) fd.append('properties[_' + faceName(f) + ' placement]', pl); });
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the designer]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor Real Estate Sign Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Real Estate Sign Proof'));
      else if (files.proof) fd.append('properties[_Ardor Real Estate Sign Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Real Estate Sign Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', 'We\'ll email you a proof to approve before printing');
      if (approval) {
        fd.append('properties[Approved by]', approval.name);
        fd.append('properties[Approved on]', approval.when);
        fd.append('properties[_Approver email]', approval.email);
        fd.append('properties[_Approver phone]', approval.phone);
      }
      var tooBig = false;
      faces.forEach(function (f) {
        var bl = files[f]; if (!bl) return;
        if (bl.size <= MAXPDF) fd.append('properties[_Ardor Real Estate Sign Print File ' + faceName(f) + ' - ' + labelStamp + ']', pdfFile(bl, 'Ardor Real Estate Sign Print File ' + faceName(f)));
        else tooBig = true;
      });
      if (tooBig) files.notes.push('A print file was over 25 MB, so it was not attached. Use the original artwork file.');
      var g = c.sign.geo, rg = c.rider ? c.rider.geo : null;
      var zones = function (gg) { return gg.hidden.length ? '; covered: ' + gg.hidden.map(function (z) { return (z.why || 'hidden') + ' ' + fmt(z.w) + ' x ' + fmt(z.h) + ' in at ' + fmt(z.x) + ', ' + fmt(z.y); }).join(', ') : ''; };
      var pnote = ['Sign ' + c.key + ' (' + productLabel(c) + ', ' + sizeName(c.key) + '): page ' + fmt(g.W) + ' x ' + fmt(g.H) + ' in, visible area ' + visTxt(g) + ' at ' + fmt(g.vis.x) + ', ' + fmt(g.vis.y) + ' in from the page top-left' + zones(g) + (g.holes.length ? '; holes: ' + g.holes.map(function (h) { return fmt(h[2]) + ' in at ' + fmt(h[0]) + ', ' + fmt(h[1]); }).join(', ') : '') + '.'];
      if (rg) pnote.push('Rider ' + c.riderSize + ': page ' + fmt(rg.W) + ' x ' + fmt(rg.H) + ' in, visible area ' + visTxt(rg) + zones(rg) + '.');
      pnote.push('SKU ' + (c.v.sku || skuOf(c.key, c.combo, c.pack)) + '. Options: ' + optText(c) + '. Quantity: ' + qtyLabel(c.qty, c) + '. Delivery: ' + (c.delivery === 'pickup' ? 'pickup in Snohomish' : 'ship to the customer (blind ship)') + '.');
      if (c.sides === 2) pnote.push(c.bm.sign === 'different' ? 'Sign: different art on the back: use the Sign Front file for the front and the Sign Back file for the back (the back as seen from behind).' : 'Sign: same art on both sides: use the Sign Front file for both sides.');
      if (c.rider && c.rsides === 2) pnote.push(c.bm.rider === 'different' ? 'Rider: different art on the back: use the Rider Front and Rider Back files.' : 'Rider: same art on both sides: use the Rider Front file for both sides.');
      if (faces.some(function (f) { return files[f]; })) pnote.push('Each print file is the template page of its piece, art to the page edge (covered zones included), no guides, 100% scale.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      var skipArt = files.skipArt || {};
      faces.forEach(function (f) {
        var a = ART[f]; if (!a || skipArt[f]) return;
        fd.append('properties[Ardor Real Estate Sign Artwork ' + faceName(f) + ' - ' + labelStamp + ']', a.file, 'Ardor Real Estate Sign Artwork ' + faceName(f) + ' ' + fileStamp + ext(a.name));
      });
      if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, sku: c.v.sku || '', sign: c.key, combo: c.combo, pack: c.pack, s: c.sides, rider: c.riderSize, rs: c.rsides, o: c.order, flag: c.flag, b: c.sides === 2 ? c.bm.sign : '', rb: c.rsides === 2 ? c.bm.rider : '', n: c.qty, each: p.each, total: p.charged, del: c.delivery, page: [g.W, g.H], vis: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], rpage: rg ? [rg.W, rg.H] : null }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      track('ardor_realestate_added_to_cart', { value: p.charged, sign: c.key, family: c.famId, combo: c.combo, pack: c.pack, rider: c.riderSize, order: c.order, quantity: c.qty });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Options: ' + optText(c));
    printedFaces(c).forEach(function (f) { var a = ART[f]; if (a) lines.push(faceName(f) + ' artwork: ' + a.name + ' (I will send the file)'); });
    if (c.sides === 2) lines.push('Sign back: ' + backLabel('sign').toLowerCase());
    if (c.rider && c.rsides === 2) lines.push('Rider back: ' + backLabel('rider').toLowerCase());
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + qtyLabel(c.qty, c) + ' x ' + money(p.each) + ')');
    return lines.join('\n');
  }

  function openQuote(want) {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText() + (typeof want === 'number' && want > MAX_QTY ? '\nQuantity wanted: ' + want : '');
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Real estate signs from the Ardor Real Estate Sign Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f), 'ask'); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f), 'ask'); });
      $$('[data-abb-face]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.face = b.getAttribute('data-abb-face') === 'back' ? 'back' : 'front'; S.back = S.face === 'back';
          render(); view3d(S.back ? 'back' : 'front');
        });
      });
      // Sign / Rider: the piece being designed (the rider only when the order has one)
      $$('[data-abb-piece]').forEach(function (b) {
        b.addEventListener('click', function () {
          var pz = b.getAttribute('data-abb-piece') === 'rider' ? 'rider' : 'sign';
          if (pz === S.piece) return;
          goFace(fid(pz, 'front'));
        });
      });
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_realestate_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindStand();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // quantity box, the "more than 100" quote link and the PDF proof button on the tool rail
  function bindStand() {
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v >= 1) setQty(Math.min(MAX_QTY, v)); if (v > MAX_QTY) { q.value = String(MAX_QTY); openQuote(v); } });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // the real estate sign designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorRealestateBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); PS.preview(B.proof); });
    B.proof._btn = btn;
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    window.ArdorRealestateBuilder = {
      state: S, specs: SPECS, fams: famsShown, keys: function (f) { return keysShown(famOf(f || cfg().famId)); }, live: function () { return LIVE; }, cfg: cfg, price: price, render: render,
      variantFor: variantFor, parseSku: parseSku, sku: skuOf, codes: codesFor, packs: packsFor, geo: faceGeo, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); }, printedFaces: function () { return printedFaces(cfg()); },
      pickFamily: pickFamily, pickSign: pickSign, pickOpt: pickOpt, pickPack: pickPack, pickBackMode: pickBackMode, goFace: goFace, setZoom: setZoom,
      faceCanvas: function (face) { return paintFaceCanvas(cfg(), face); },
      // names for the template download (assets/ardor-realestate-tpl.js)
      tplInfo: function () { var c = cfg(); return { key: c.key, product: productLabel(c), size: sizeLabel(c), sizeName: sizeName(c.key), sides: c.sides, sidesText: sidesLabel(c), rider: c.riderSize, riderSides: c.rsides, riderSize: c.rider ? pieceSize(c.rider.geo) : '', Wi: c.sign.Wi, Hi: c.sign.Hi }; },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-realestate-layers-kit.js, ardor-realestate-ai.js and ardor-realestate-kit.js. Sizes are in inches of the
    // piece being edited (c.Wi x c.Hi); face ids 'front', 'back', 'rider-front', 'rider-back'.
    var safeOf = function (face) { var c = cfg(), f = face ? normFace(face) : fid(c.piece, S.face), g = faceGeo(c, f), r = g.safeR; return { x: r.x, y: r.y, w: Math.max(1, r.w), h: Math.max(1, r.h) }; };
    var infoOf = function (key) {
      var k = normKey(key); if (!k) return null;
      var e = KEYS[k], g = geoFor(k, 'sign', '', false), riders = {};
      Object.keys(e.riders || {}).forEach(function (r) { var rg = geoFor(k, 'rider', r, false); riders[r] = { w: rg.W, h: rg.H, visible: { w: rg.vis.w, h: rg.vis.h }, faces: rg.faces }; });
      return { key: k, fam: e.fam, family: e.fam, group: e.fam, faces: +e.sign.faces === 2 ? 2 : 1, name: famOf(e.fam).name + ', ' + sizeName(k), visible: { w: g.vis.w, h: g.vis.h }, page: { w: g.W, h: g.H }, riders: riders };
    };
    window.ArdorRealestateAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[normFace(face)] || null; },
      setArt: function (face, a) { ART[normFace(face)] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      piece: function () { return cfg().piece; },
      face: function () { return fid(cfg().piece, S.face); },
      faces: function () { var c = cfg(), out = ['front']; if (c.sides === 2) out.push('back'); if (c.rider) { out.push('rider-front'); if (c.rsides === 2) out.push('rider-back'); } return out; },
      printedFaces: function () { return printedFaces(cfg()); },
      // the face that can be edited now (null = a back showing "Same as front"); showFace = the face the layout shows
      editFace: function () { var c = cfg(); if (S.face === 'back') return c.pieceSides === 2 && c.backMode === 'different' ? fid(c.piece, 'back') : null; return fid(c.piece, 'front'); },
      showFace: function () { var c = cfg(); return S.face === 'back' && c.pieceSides === 2 && c.backMode === 'different' ? fid(c.piece, 'back') : fid(c.piece, 'front'); },
      pageOf: function (face) { var c = cfg({ piece: pieceOf(normFace(face || fid(cfg().piece, 'front'))) }); return { Wi: c.Wi, Hi: c.Hi, piece: c.piece }; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; },
      // where the page sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = page corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      // the visible area of a face (AI designs are fitted inside it, then extended over the whole page of its piece), and
      // the safe rect (new text, logos and templates go there)
      faceBox: function (face) { var c = cfg(), g = faceGeo(c, normFace(face || fid(c.piece, S.face))); return { x: g.vis.x, y: g.vis.y, w: g.vis.w, h: g.vis.h }; },
      pageBox: function (face) { var c = cfg({ piece: face ? pieceOf(normFace(face)) : S.piece }); return { x: 0, y: 0, w: c.Wi, h: c.Hi }; },
      safeBox: safeOf,
      // the guides of the piece and face shown (for the kit's background layer redraw)
      guides: function (face) { var c = cfg(), g = faceGeo(c, face ? normFace(face) : fid(c.piece, S.face)); return { visible: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], hidden: g.hidden.map(function (z) { return [z.x, z.y, z.w, z.h]; }), holes: g.holes.map(function (h) { return h.slice(); }), keep: g.keep.map(function (z) { return [z.x, z.y, z.w, z.h]; }), safe: safeOf() }; },
      goFace: goFace, pickSign: pickSign, pickFamily: pickFamily, pickOpt: pickOpt, pickBackMode: pickBackMode,
      signKey: function () { return cfg().key; }, signInfo: infoOf, readVariant: readLate, maxQty: maxQty,
      signName: function () { var c = cfg(); return c.piece === 'rider' && c.rider ? pieceSize(c.rider.geo) + ' rider (' + productLabel(c) + ', ' + sizeName(c.key) + ' sign)' : productLabel(c) + ', ' + sizeName(c.key); },
      signs: function () { var out = []; famsShown().forEach(function (f) { out = out.concat(keysShown(f)); }); return out; },
      // turn the rider on at a size (AI hand-off); false when this sign has no such rider
      setRider: function (size) {
        var c = cfg(), g = c.fam.groups.filter(function (x) { return x.role === 'rider'; })[0]; if (!g) return false;
        var want = String(size || ''), v = realVals(g).filter(function (x) { return x.rider && riderOf(c.key, x.rider) && (!want || riderOf(c.key, x.rider) === want); })[0];
        if (!v) return false; if (c.sel[g.id] !== v.v) pickOpt(g.id, v.v); return !!cfg().rider;
      },
      // the stand designer's names, for code written against it
      standKey: function () { return cfg().key; }, standInfo: infoOf, pickStand: pickSign,
      standName: function () { var c = cfg(); return productLabel(c) + ', ' + sizeName(c.key); },
      stands: function () { var out = []; famsShown().forEach(function (f) { out = out.concat(keysShown(f)); }); return out; }
    };
    window.ArdorRealestateBuilder.proof = { noun: 'real estate signs', file: 'Ardor Real Estate Sign Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
      var c = cfg(), waits = FACES.map(function (k) { return ART[k]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
      return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
    } };
try { document.dispatchEvent(new CustomEvent('ardor:realestate-api')); } catch (e) {}
    mountPdf(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
